import { render } from "./RentalTransfer.vue?vue&type=template&id=3dd63ccc&scoped=true"
import script from "./RentalTransfer.vue?vue&type=script&lang=js"
export * from "./RentalTransfer.vue?vue&type=script&lang=js"

import "./RentalTransfer.vue?vue&type=style&index=0&id=3dd63ccc&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd63ccc"]])

export default __exports__